var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainbox"},[_c('div',{staticClass:"err"},[_vm._v("404")]),_c('div',{staticClass:"msg"},[_vm._v("Looks like you reached a page that does not exist!")])])
}]

export { render, staticRenderFns }